// extracted by mini-css-extract-plugin
module.exports = {"makerWhite":"white","makerGreen":"#385461","footer":"footer_footer__uioVx","title":"footer_title__3DKPr"};